import React from "react";
import SimActivation from "../../containers/activationSales/components/simConnectivity/components/simActivation";
import DailyActivatingOutlet from "../../containers/activationSales/components/simConnectivity/components/dailyActivatingOutlet";
import Top5Retailers from "../../containers/activationSales/components/simConnectivity/components/top5Retailers";
import Bottom5Retailers from "../../containers/activationSales/components/simConnectivity/components/bottom5Retailers";
import Last7Days from "../../containers/activationSales/components/simConnectivity/components/last7Days";
import CafPendency from "../../containers/activationSales/components/simConnectivity/components/cafPendency";
//import { StockTabs } from "../../screens/home/components/salesTwoInner/innerBoxes/stockNew/components/index";
import { StockTabs } from "../../containers/deviceSales/stock/components/stockTab";
import SimBillingTabs from "../../containers/activationSales/components/simBilling/components/simBillingTabs";
import ActivationSalesDistributionTabs from "../../containers/activationSales/components/distribution/components/activationSalesDistributionTabs";
//import { RechargeDistributionTabs } from '../../screens/rechargeSales/components/distribution/components/index'
import { RechargeDistributionTabs } from "../../containers/rechargeSales/distribution/components/rechargeSalesDistributionTabs";
// import { DeviceDistributionTabs } from '../../screens/home/components/salesTwoInner/innerBoxes/Distribution/components/index';
import DeviceSalesDistributionTabs from "../../containers/deviceSales/distribution/components/deviceSalesDistributionTabs";
import EarningsTabs from "../../containers/myEarnings/components/EarningTabs";
import OthersWalletBalance from "../../containers/rechargeSales/others/othersWalletBalance";
import OthersTop5Retailers from "../../containers/rechargeSales/others/othersTop5Retailers";
import OthersBottom5Retailers from "../../containers/rechargeSales/others/othersBottom5Retailers";
import OthersLast7Days from "../../containers/rechargeSales/others/othersLast7Days";

export default function PanelSection(sectionData) {
  const { tileName, tileCode, sectionName, ...other } = sectionData;
  return {
    "MDN Sim Connectivity": () => {
      let panel = (
        {
          "SIM Activation": () => {
            return <SimActivation data="" tileName={tileName} {...other} />;
          },
          "Daily Activating Outlet": () => {
            return (
              <DailyActivatingOutlet data="" tileName={tileName} {...other} />
            );
          },
          "Top 5 Retailers": () => {
            return <Top5Retailers data="" tileName={tileName} {...other} />;
          },
          "Bottom 5 Retailers": () => {
            return <Bottom5Retailers data="" tileName={tileName} {...other} />;
          },
          "Last 7 days SIM Activation Trend ( Always from current day -7)":
            () => {
              return <Last7Days data="" tileName={tileName} {...other} />;
            },
          "Order Input Details": () => {
            return <CafPendency data="" tileName={tileName} {...other} />;
          },
        }[tileName] ||
        (() => {
          return null;
        })
      )();
      return panel;
    },
    Stock: () => {
      return <StockTabs data="" tileName={sectionData.tileName} {...other} />;
    },
    "Sim Billing": () => {
      return <SimBillingTabs data="" {...other} />;
    },
    "Activation Distribution": () => {
      return <ActivationSalesDistributionTabs data="" {...other} />;
    },
    Device: () => {
      return <EarningsTabs {...other} />;
    },
    Activation: () => {
      return <EarningsTabs {...other} />;
    },
    Recharge: () => {
      return <EarningsTabs {...other} />;
    },
    "Recharge Distribution": () => {
      return <RechargeDistributionTabs data={sectionData} {...other} />;
    },
    Distribution: () => {
      return (
        <DeviceSalesDistributionTabs
          data=""
          tileName={sectionData.tileName}
          {...other}
        />
      );
    },
    "Recharge Other": () => {
      let panel = (
        {
          T5R: () => {
            return <OthersTop5Retailers data="" {...other} />;
          },
          B5R: () => {
            return <OthersBottom5Retailers data="" {...other} />;
          },
          RWT: () => {
            return <OthersWalletBalance data="" {...other} />;
          },
          RST: () => {
            return <OthersLast7Days data="" {...other} />;
          },
        }[tileCode] ||
        (() => {
          return null;
        })
      )();
      return panel;
    },
  }[sectionName]();
}
